import { utils, LitElement, html } from '@hh/global.js'
const { serializeForm } = utils

class HHSlideoutSwatchSelector extends LitElement {
  constructor() {
    super()

    this.form = this.querySelector('form')
    this.atcButton = this.querySelector('#add_to_cart')
    this.slidePanel = this.closest('slide-panel')
  }

  connectedCallback() {
    super.connectedCallback()
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.form.removeEventListener('submit', this.onSubmitHandler.bind(this))
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    const formData = JSON.parse(serializeForm(this.form))
    const selectedVariantId = formData.id

    const isNotifyMe =
      this.atcButton.classList.contains(atcStatusTitle.notifyMeClass[0]) ===
      true
    if (isNotifyMe) {
      const productId = this.form
        .querySelector('input[name="id"]')
        ?.getAttribute('data-product-id')
      const productVariantsComponent = document.querySelector(
        `product-variants[variantid][product-id="${productId}"]`
      )
      if (productVariantsComponent) {
        let selectedItem = null
        productVariantsComponent.product.variants.forEach((item) => {
          if (Number(selectedVariantId) === item.id) {
            selectedItem = item
          }
        })
        const params = {
          productId: productVariantsComponent.product.id,
          productTitle: selectedItem?.name,
          sku: selectedItem?.sku,
          title: selectedItem?.title,
          image: selectedItem?.featured_image
            ? selectedItem?.featured_image.src
            : productVariantsComponent.product.featured_image,
        }
        productVariantsComponent.fillNotifyMeModal(params)
      }
    } else {
      await window.__CART__CONTROLLER__.add({
        payload: formData,
      })

      // Fire Nosto add-to-cart attribution if the slideout was opened from
      // inside a Nosto recommendation placement.
      const slideoutContainer = document.querySelector(
        '.slideout-swatch-selector[data-nosto-placement-id]'
      )
      if (slideoutContainer) {
        const productId = this.form
          .querySelector('input[name="id"]')
          ?.getAttribute('data-product-id')
        const placementId = slideoutContainer.dataset.nostoPlacementId
        if (productId && placementId) {
          document.dispatchEvent(
            new CustomEvent('click::add-to-cart', {
              detail: { product_id: productId, placement_id: placementId },
            })
          )
        }
        delete slideoutContainer.dataset.nostoPlacementId
      }

      this.slidePanel._close()
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-slideout-swatch-selector', HHSlideoutSwatchSelector)
